import {SectionId, QuestionnaireId, QuestionGroupId} from "../../Types";
import {invalidateQueries, q} from "../../state";
import jsonApi from "../jsonApi";

export async function updateName(
  questionnaireId: QuestionnaireId,
  sectionId: SectionId,
  questionGroupId: QuestionGroupId,
  name: string,
) {
  const res = await jsonApi.post<"ok">(
    `/vendor_toolkit/questionnaires/${questionnaireId}/sections/${sectionId}/question_groups/${questionGroupId}/name`,
    name,
  );
  await invalidateQueries([q.vendorToolkit.questionnaires.filter()]);
  return res;
}
